import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import allReducers from './reducers/index';
import { actionTypes } from './const';
import { loadingBarMiddleware } from 'react-redux-loading-bar';

const rootReducer = (state, action) => {
    if (action.type === actionTypes.LOGOUT_SUCCESS) {
        state = undefined;
    }
    return allReducers(state, action);
}

export default function configureStore() {
    return createStore(
        rootReducer,        
        applyMiddleware(loadingBarMiddleware(),thunkMiddleware)
    );
}